import { HttpErrorResponse } from '@angular/common/http';
import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { EMPTY } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

import { ACCESS_ROUTE } from 'app/access/access-routing.constant';
import { LoginService } from 'app/core/authentication/services/login.service';
import { TranslationService } from 'app/core/internationalization/translation.service';
import { VerifyEmailParams } from 'app/shared/enums/verify-email-params.enum';
import { AccountSettingsDataService } from 'app/shared/services/account-settings-data-service';

@Component({
  selector: 'kh-verify-email',
  styleUrls: ['./verify-email.component.less'],
  templateUrl: './verify-email.component.html',
  standalone: false
})
export class VerifyEmailComponent implements OnInit {
  private readonly accountSettingsDataService = inject(AccountSettingsDataService);
  private readonly _translationService = inject(TranslationService);
  private readonly activatedRoute = inject(ActivatedRoute);
  private readonly loginService = inject(LoginService);

  public errorMessage = '';
  public loginRoute = ACCESS_ROUTE.route();

  public ngOnInit(): void {
    this._translationService.instant('VERIFY_EMAIL.INVALID_EMAIL_VERIFICATION_CODE');
    this._translationService.instant('VERIFY_EMAIL.THIS_EMAIL_HAS_ALREADY_BEEN');

    const code = this.activatedRoute.snapshot.paramMap.get(VerifyEmailParams.Code);

    if (code) {
      this.accountSettingsDataService.verifyEmail(code)
        .pipe(
          tap((res) => {
            this.loginService.setTokenResponse(res);
            this.loginService.redirectOnSuccess().catch((error: unknown) => console.error(error));
          }),
          catchError((res: HttpErrorResponse) => {
            this.errorMessage = this._translationService.instant(res.error.Errors[0]);

            return EMPTY;
          })
        )
        .subscribe();
    }
  }
}
